import { SignInResponseSchema } from '../auth-sso/signed-in-session.schema';
/**
 * Auth Refresh Response Schema
 * POST /api/v2/auth/refresh
 *
 * A refresh mints exactly what a sign-in mints — the client feeds it to the
 * same setAuth() — minus the id_token: refreshing does not touch the IdP
 * session, so the stored logout hint stays the one the login callback set.
 */ export const AuthRefreshResponseSchema = SignInResponseSchema;

//# sourceMappingURL=auth-refresh.schema.js.map